import $ from 'jquery';
import {findObjectById, getLocacion} from '../../util';



export class RespuestaApi {
    
    static activar(id, token) {  
       return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/respuesta/activar/"+id,
			type: "PUT",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
     static borrar(id, token) {  
       return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/respuesta/"+id,
			type: "DELETE",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
    static getRespuestaList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token ) {
        
         return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/respuesta?page="+pagina+"&size="+regitrosPorPagina+"&filtro="+filtro+"&activos="+showActivos,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    
    static getRespuesta(id, token ) {  
         return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/respuesta/"+id,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    static save(respuesta, token ) {          
      let respuestaEnvio = Object.assign({}, respuesta);
		let comando="POST";
		if (respuestaEnvio.id > 0) {
			comando="PUT";			
		} 
		respuestaEnvio=JSON.stringify(respuestaEnvio);
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/respuesta/",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: respuestaEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}   
    
    static getRespuestaCombo(token ) {

		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/respuesta/combo/",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
     

    
}